// ユーザー・権限管理 API（users / usersList / permissionSets / permissions）。
// 2026-05-15 リファクタで src/api.ts から分離。
import { request } from './_request'

// === ユーザー一覧（読み取り専用、メンション候補用） ===
export const usersList = {
  list: () => request<import('../types').User[]>('/users'),
}

// === ユーザー管理 ===
export const users = {
  list: () => request<import('../types').User[]>('/users'),
  create: (data: {
    name: string; email: string; password: string; role?: string;
    allowedPages?: string[] | null; permissionSetId?: string | null;
    canViewSecret?: boolean;
  }) => request<{ id: string }>('/users', { method: 'POST', body: JSON.stringify(data) }),
  update: (data: Partial<import('../types').User> & {
    password?: string; permissionSetId?: string | null;
    canViewSecret?: boolean;
  }) => request('/users', { method: 'PUT', body: JSON.stringify(data) }),
}

// === 権限セット ===
export const permissionSets = {
  list: () => request<import('../types').PermissionSet[]>('/permission_sets'),
  create: (data: { name: string; description?: string; allowedPages: string[] }) =>
    request<{ id: string; ok: boolean }>('/permission_sets', {
      method: 'POST', body: JSON.stringify(data),
    }),
  update: (data: { id: string; name?: string; description?: string; allowedPages?: string[] }) =>
    request<{ ok: boolean }>('/permission_sets', {
      method: 'PUT', body: JSON.stringify(data),
    }),
  remove: (id: string) =>
    request<{ ok: boolean }>('/permission_sets', {
      method: 'DELETE', body: JSON.stringify({ id }),
    }),
}

// === 権限管理（admin専用） ===
export interface PermissionEntry {
  userId: string
  userName: string
  userEmail: string
  userRole: string
  permissionKey: string
  departmentId: string | null
  departmentName: string | null
  grantedAt: string
  grantedBy: string | null
}

export const permissions = {
  list: () =>
    request<{ items: PermissionEntry[]; availableKeys: string[] }>('/permissions'),
  listByUser: (userId: string) =>
    request<{ items: any[] }>(`/permissions?userId=${encodeURIComponent(userId)}`),
  grant: (data: { userId: string; permissionKey: string; departmentId?: string | null }) =>
    request<{ ok: boolean }>('/permissions', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  revoke: (data: { userId: string; permissionKey: string; departmentId?: string | null }) =>
    request<{ ok: boolean }>('/permissions', {
      method: 'DELETE',
      body: JSON.stringify(data),
    }),
}
